import axios from 'axios';
import ReactPaginate from 'react-paginate'
import React, { Component } from 'react'
import "../../services/ApiRest";
import "../../coordinacionacad/coordacad.css";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import { Alert } from 'bootstrap';
import * as xlsx from "xlsx";

const urlListPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCarreras = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarAsignMatCiclo = ApiUrl + "ListarAsignMatCiclo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarEstudCarrPeriod = ApiUrl + "listestudasignamatri" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInfoCarrera = ApiUrl + "infocarrselect" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListParalelos = ApiUrl + "listodosparalelos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 10;

export default class CalificacionesEstud extends Component {

    constructor(props) {
        super(props)
        this.state = {
            carrera: [],
            listparalelos: [],
            estado: "",
            listasignaturas: [],
            listaperiodos: [],
            idPeriodo: 1,
            listaasigencab: [],
            listaniveles: [],
            //Variables para búsqueda
            estud: [],
            EstudianteBackup: [],
            textBuscar: "",
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,

        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalReportAsignatutasEst: false });
        }
    }
    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }

    componentDidMount() {
        //Listar las carreras
        axios.get(urlListarCarreras)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

        //listar todos los periodos
        axios
            .get(urlListPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ listaperiodos });
                }
            })
        //Listar todos los paralelos
        axios
            .get(urlListParalelos)
            .then(response => {
                if (response.data.success == true) {
                    const listparalelos = response.data.data;
                    const cant = listparalelos.length;
                    if (cant != 0) {
                        this.setState({ listparalelos });
                    }
                }
            })

    }

    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;
            //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1

        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }
    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }


    handleChangeSelectNivel = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        axios
            .post(urlInfoCarrera, {
                idCarreraS: this.state.idCarrera
            })
            .then(response => {
                const codigocarrest = response.data.objcarrea[0].id_carrera;
                const descripcarrest = response.data.objcarrea[0].descripcion_carrera;
                const nivelcarrest = response.data.objcarrea[0].num_niveles;
                this.setState({ codigoCarrE: codigocarrest });
                this.setState({ descripCarrE: descripcarrest });
                this.setState({ numnivelE: nivelcarrest });
                let listaniveles1 = []
                for (let i = 1; i <= nivelcarrest; i++) {
                    let fila = {
                        codnivel: i,
                        valor: i
                    };
                    listaniveles1.push(fila);
                }
                this.setState({ listaniveles: listaniveles1 });
            })
    }
    handleChangematcarrnivel = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        var nuevalistaasig = null;
        axios
            .post(UrlListarAsignMatCiclo, {
                idCarrera: this.state.idCarrera,
                idCiclo: this.state.nivelEstu,
            })
            .then(response => {
                var array = response.data.data;
                this.setState({ listaasigencab: array });
                axios.post(urlListarEstudCarrPeriod, {
                    idPeriodSelect: this.state.idPeriodo,
                    idCarreraSelect: this.state.idCarrera,
                    idListaAsigna: array,
                    idCicloSelect: this.state.nivelEstu,
                    idParaleloSelect: this.state.idParalelo
                })
                    .then(respuesta => {

                        if (respuesta.data.success == true) {
                            listaauxiliar = respuesta.data.data;
                            const estud = respuesta.data.data;
                            this.setState((state) => {
                                return { estud: estud }
                            }
                            );
                            const EstudianteBackup = estud;
                            this.setState((state) => {
                                return { EstudianteBackup: EstudianteBackup }
                            });
                            //PAGINACION
                            this.state.itemOffset = 0;
                            const endOffset = this.state.itemOffset + itemsPerPage;
                            this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                            this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                            this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                            this.setState((state) => {
                                return { itemOffset: state.itemOffset + endOffset }
                            });
                            //FIN  DE LA PAGINACION
                        } else {
                            this.setState({ error: "¡No existe información!" });
                            swal({
                                text: "¡No existe información!",
                                icon: "info",
                                button: "Aceptar",
                            });
                        }
                    })
            })
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="far fa-sticky-note me-2"></i>
                        <b className="mb-0 fw-semibold">Acta de Calificaciones</b>
                    </div>

                    <div className="p-3 rounded-3">
                        {/* Filtros */}
                        <div className="row g-3 mb-3">
                            {/* Buscar */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-magnifying-glass me-1"></i> Buscar
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={this.state.text}
                                    placeholder="Buscar..."
                                    onChange={text => this.filter(text)}
                                />
                            </div>

                            {/* Período */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-calendar me-1"></i> Período
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idPeriodo"
                                    value={this.state.idPeriodo}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>Seleccione el período</option>
                                    {this.state.listaperiodos.map(p => (
                                        <option key={p.id_periodo_academico} value={p.id_periodo_academico}>
                                            {p.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Carrera */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">Carrera</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCarrera"
                                    value={this.state.idCarrera}
                                    onChange={this.handleChangeSelectNivel}
                                >
                                    <option value="undefined" selected disabled>Seleccione una carrera</option>
                                    {this.state.carrera.map(c => (
                                        <option key={c.id_carrera} value={c.id_carrera}>
                                            {c.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Paralelo */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-magnifying-glass me-1"></i> Paralelo
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idParalelo"
                                    value={this.state.idParalelo}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>Seleccione un paralelo</option>
                                    {this.state.listparalelos.map(p => (
                                        <option key={p.id_paralelo} value={p.id_paralelo}>
                                            {p.nombre_paralelo}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Nivel */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">Nivel</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="nivelEstu"
                                    value={this.state.nivelEstu}
                                    onChange={this.handleChangematcarrnivel}
                                >
                                    <option value="undefined" selected disabled>Seleccione</option>
                                    {this.state.listaniveles.map(n => (
                                        <option key={n.codnivel} value={n.codnivel}>
                                            {n.valor}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Tabla de calificaciones */}
                        <h6 className="fw-bold text-center mb-3 text-azul small">Acta de Calificaciones</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-hover align-middle small">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-azul">Nº</th>
                                        <th className="text-azul">CÉDULA</th>
                                        <th className="text-azul">PRIMER APELLIDO</th>
                                        <th className="text-azul">SEGUNDO APELLIDO</th>
                                        <th className="text-azul">PRIMER NOMBRE</th>
                                        <th className="text-azul">SEGUNDO NOMBRE</th>
                                        {this.state.listaasigencab.map(a => (
                                            <th key={a.id_asignatura} className="text-azul">
                                                {a.descripcion_asignatura}
                                            </th>
                                        ))}
                                        <th className="text-azul">TOTAL</th>
                                        <th className="text-azul">PROMEDIO</th>
                                        <th className="text-azul">VALORACIÓN</th>
                                    </tr>
                                </thead>
                                <tbody className="text-azul small">
                                    {this.state.currentItems?.map(consola => (
                                        <tr className="list-afiliados" key={consola.id_estudiante}>
                                            <td>{consola.num_est}</td>
                                            <td>{consola.numero_identificacion_estudiante}</td>
                                            <td>{consola.primer_apellido_estudiante}</td>
                                            <td>{consola.segundo_apellido_estudiante}</td>
                                            <td>{consola.primer_nombre_estudiante}</td>
                                            <td>{consola.segundo_nombre_estudiante}</td>
                                            {consola.lista_calif_asig.map((c, i) => (
                                                <td key={i}>
                                                    {(c.calificacion_prom < 7 || c.asistencia < 70)
                                                        ? <span className="mensajesusp small">{c.calificacion_prom}</span>
                                                        : <span className="small">{c.calificacion_prom}</span>}
                                                </td>
                                            ))}
                                            <td>{consola.total}</td>
                                            <td>{consola.promedio}</td>
                                            <td>{consola.valoracion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Paginador */}
                        <div className="d-flex justify-content-center mt-3">
                            <ReactPaginate
                                nextLabel=">"
                                previousLabel="<"
                                onPageChange={this.handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                containerClassName="pagination pagination-sm-custom"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
